import API from "./../../../utils/services";
var AxiosNoAuth = API.noAuth;
export var loginApi = function (body) {
    return AxiosNoAuth.post("/user/login", body).then(function (res) { return res.data; }).catch(function (err) { return err.response.data; });
};
export var registerApi = function (body) {
    return AxiosNoAuth.post("/user/register", body).then(function (res) { return res.data; }).catch(function (err) { return err.response.data; });
};
export var verifyCodeApi = function (code, phone) {
    return AxiosNoAuth.get("/user/phone/" + phone + "/verification/" + code).then(function (res) { return res.data; });
};
export var verifyEmailpi = function (email) {
    return AxiosNoAuth.post("/user/availability/email/" + email).then(function (res) { return res.data; });
};
export var verifyPhoneApi = function (phone) {
    return AxiosNoAuth.post("/user/availability/phone/" + phone).then(function (res) { return res.data; });
};
export var resendCodeApi = function (phone) {
    return AxiosNoAuth.post("/user/phone/code/" + phone).then(function (res) { return res.data; });
};



//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/ducks/api.ts
// module id = 715
// module chunks = 0